module.exports = __webpack_public_path__ + "static/media/sunIcon.9f4dc347.svg";